export const WISHLIST_QUERY = /* GraphQL */ `
    {
        customer {
            wishlists {
                id
                items_count
                name
                sharing_code
                visibility
                items_v2 {
                    items {
                        id
                        description
                        quantity
                        product {
                            id
                            url_key
                            name
                            price_range {
                                __typename
                                minimum_price {
                                    __typename
                                    regular_price {
                                        __typename
                                        value
                                        currency
                                    }
                                    final_price {
                                        __typename
                                        value
                                        currency
                                    }
                                    discount {
                                        __typename
                                        amount_off
                                    }
                                }
                                maximum_price {
                                    __typename
                                    final_price {
                                        __typename
                                        value
                                        currency
                                    }
                                }
                            }
                            small_image {
                                __typename
                                url
                            }
                            sku
                            ... on ConfigurableProduct {
                                variants {
                                    __typename
                                    attributes {
                                        __typename
                                        uid
                                        value_index
                                    }
                                    product {
                                        sku
                                    }
                                }
                            }
                        }
                        ... on ConfigurableWishlistItem {
                            configurable_options {
                                id
                                value_id
                                option_label
                                value_label
                            }
                        }
                    }
                }
            }
        }
    }
`
